import { Injectable } from "@angular/core";

// import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClient } from "@angular/common/http";
import { Observable, Subject, EMPTY } from "rxjs";
import { catchError } from "rxjs/operators";
// import { ApplicationUtilsService, BrowserDetect } from './application_utils.service';

// import { postWrapperService } from './http_wrapper.service';

@Injectable()
export class DocumentLoaderService {
  /*    constructor(private httpClient: HttpClient, private httpHeaders: HttpHeaders) {

    }
*/
  constructor(private httpClient: HttpClient) {}

  /*
    showDocument( url: string, data: any, documentType: string, bestandsnaam?: string, openDirect?: boolean, bestemming?: string) {
        let subject = new Subject<{file: any, naam: any, documentType: any}>();

        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options = { headers: headers, responseType: 'blob' };

        openDirect = (openDirect == null) ? true : openDirect;

        this.httpClient.post(url, data, options)
            .catch((err: any, caught: Observable<any>) => {
                subject.error(err);
                const reader: FileReader = new FileReader();

                const obs = Observable.create((observer: any) => {
                    reader.onloadend = (e) => {
                        observer.error(JSON.parse(reader.result));

                        let responseJSON = JSON.parse(reader.result);
                        let content = { content: {error_text: responseJSON.message}, state: "ERROR" };

//						this.httpClient.createDialog(content);
                        observer.complete();
                    }
                });
                reader.readAsText(err);
                subject.complete();
                return obs;
            })
            .subscribe((response) => {
                let naam = (bestandsnaam == null) ? data.bestandsnaam : bestandsnaam;
                let file = response;

                if (openDirect) {
                    this.openFile( file, naam, documentType );
                }

                let fileData = { file: file, naam: naam, documentType: documentType };
                subject.next( fileData );
                subject.complete();
            });
        return subject.asObservable();
    }
*/
  showMultipleDocuments(
    url: string,
    data: any,
    documentType: string
  ): Observable<any> {
    let subject = new Subject<any>();

    this.httpClient
      .post(url, data)
      .pipe(
        catchError((err: any, caught: Observable<any>) => {
          subject.error(err);
          return EMPTY;
        })
      )
      .subscribe((res) => {
        let documenten = res;
        subject.next(documenten);
      });
    return subject.asObservable();
  }

  openFileFromB64(
    file: any,
    bestandsnaam: string,
    documentType: string,
    sliceSize = 512
  ) {
    const byteCharacters = atob(file);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: documentType });
    this.openFile(blob, bestandsnaam, documentType);
  }

  openFile(file: any, bestandsnaam: string, documentType: string) {
    let browserDetect = new BrowserDetect();
    browserDetect.init();

    if (bestandsnaam == null) {
      bestandsnaam = "naamloos";
    }

    if (documentType === "application/pdf") {
      if (!bestandsnaam.toLowerCase().endsWith(".pdf")) {
        bestandsnaam = bestandsnaam + ".pdf";
      }
    } else if (documentType === "application/xml") {
      if (!bestandsnaam.toLowerCase().endsWith(".xml")) {
        bestandsnaam = bestandsnaam + ".xml";
      }
    }

    // De onderstaande code is het gebruik van msSaveorOpenBlob uitgecommentarieerd.
    // Na de upgrade van typescript naar versie 4.6.4 (als onderdeel van de upgrade naar Angular 13)
    // wordt msSaveOrOpenBlob in interface Navigator namelijk niet meer ondersteund.
    // Deze werd gebruikt tijdens het gebruik van Internet Explorer (IE).
    if (
      browserDetect.browser == "IE" &&
      window.navigator
      // && window.navigator.msSaveOrOpenBlob
    ) {
      // Open of save het xml-bestand via window.navigator in IE11
      // window.navigator.msSaveOrOpenBlob(file, bestandsnaam);
      return;
    }

    var fileURL = URL.createObjectURL(new Blob([file], { type: documentType }));
    if (documentType === "application/pdf") {
      window.open(fileURL);
    } else {
      // Download het xml-bestand via window.open voor overige browsers
      var a = document.createElement("a");
      a.href = fileURL;
      a.download = bestandsnaam;
      a.type = documentType;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }

  /*   createDialog(content, bestemming?: string){
       let error = {header: "Er is een fout opgetreden", melding:content.content.error_text,  type:ERROR, isPopup:content.isPopup, bestemming: bestemming} as EcertMelding;
       this.meldingService.voegMeldingToe(error);

   }
*/
}

export class BrowserDetect {
  browser: any;
  version: any;
  versionSearchString: any;

  dataBrowser = [
    { string: navigator.userAgent, subString: "Edge", identity: "Edge" },
    { string: navigator.userAgent, subString: "MSIE", identity: "IE" },
    { string: navigator.userAgent, subString: "Trident", identity: "IE" },
    { string: navigator.userAgent, subString: "Firefox", identity: "Firefox" },
    { string: navigator.userAgent, subString: "Opera", identity: "Opera" },
    { string: navigator.userAgent, subString: "OPR", identity: "Opera" },

    { string: navigator.userAgent, subString: "Chrome", identity: "Chrome" },
    { string: navigator.userAgent, subString: "Safari", identity: "Safari" },
  ];

  init() {
    this.browser = this.searchString(this.dataBrowser) || "Other";
    this.version =
      this.searchVersion(navigator.userAgent) ||
      this.searchVersion(navigator.appVersion) ||
      "Unknown";
  }

  searchString(data) {
    for (let i = 0; i < data.length; i++) {
      let dataString = data[i].string;
      this.versionSearchString = data[i].subString;

      if (dataString.indexOf(data[i].subString) !== -1) {
        return data[i].identity;
      }
    }
  }

  searchVersion(dataString) {
    let index = dataString.indexOf(this.versionSearchString);
    if (index === -1) {
      return;
    }

    let rv = dataString.indexOf("rv:");
    if (this.versionSearchString === "Trident" && rv !== -1) {
      return parseFloat(dataString.substring(rv + 3));
    } else {
      return parseFloat(
        dataString.substring(index + this.versionSearchString.length + 1)
      );
    }
  }
}
